var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level__title-wrapper"},[_c('p',{staticClass:"level__title"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),(_vm.hasAccess)?_c('label',{class:[
        _vm.textClass ? ("level__title__label--" + _vm.textClass) : '',
        'level__title__label' ]},[_vm._v("\n      "+_vm._s(_vm.details)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }